import { withResponseHandler, withUnauthorizedResponseHandler } from './response-handlers';
import { tryGetAuthHeaders, AuthorizationHeaders } from './api-headers';
import { APIResponse } from '../../system-libraries/api-types';

export const withAuthHeadersAndResponseHandler = async <T>(request: (obj: { headers: AuthorizationHeaders }) => Promise<Response>): Promise<APIResponse<T>> => {
  return withUnauthorizedResponseHandler<T>(async () => {
    return withResponseHandler<T>(async () => {
      const headers = tryGetAuthHeaders();
      if (headers) {
        return request({ headers });
      } else {
        // Couldn't get valid auth headers.
        // - Simulate a 401 to request a token refresh.
        // - If a token refresh is already in flight the request will join a queue before being repeated.
        return new Response(JSON.stringify({}), { status: 401 });
      }
    });
  });
};

// TODO: add tests
export const buildPath = (url: string, data: Record<string, string>): string => {
  const regex = /:(\w+)/g;
  return url.replace(regex, (_match, p1) => {
    return data[p1] || ':' + p1;
  });
};
